<template>
  <div class="main">
    <div class="wrapper">
      <!-- <div class="left">
        <ul class="nav">
          <li
            v-for="(item,index) in nav"
            @click="changeNews(item,index)"
            :class="currentIndex == index?'selected':''"
            :key="index"
          >
            <p>{{item.title}}</p>
            <i class="el-icon-arrow-right"></i>
          </li>
        </ul>
      </div> -->
      <div class="right">
        <router-view></router-view>
      </div>
    </div>
  </div>
</template>
<script>
import Bus from "@/utils/bus.js";
export default {
  data() {
    return {
      currentIndex: 0,
      nav: [
        { title: "机构简介", url: "mjgjj" },
        { title: "章程", url: "mzc" },
        { title: "理事会", url: "mlsh" },
        { title: "法人登记证", url: "mfrdjz" },
        { title: "理事长简介", url: "mlszjj" },
        { title: "专家顾问", url: "mzjgw" },
      ]
    };
  },
  mounted() {
    this.changeIndex();
    Bus.$on("content",e=>{
      if(e=="zjgw"){
        this.changeIndex()
      }
    })
  },
  methods: {
    changeNews(item, index) {
      this.currentIndex = index;
      this.$router.push({ name: item.url });
    },
    changeIndex() {
      this.nav.some((item, index) => {
        if (
          item.url ==
          window.location.pathname
        ) {
          this.currentIndex = index;
          return true;
        }
        else{
          this.currentIndex = -1
        }
      });
    }
  },
  components: {}
};
</script>

<style lang="less" scoped>
@color: #e76d30;
.main {
  width: 100%;
  .wrapper {
    width: calc(100vw - 60px);
    margin: 0 auto;
    padding-top: 20px;
    margin-bottom: 30px;
    .right {
      width: 100%;
    }
  }
}
</style>